import { 
  Box, 
  Container, 
  Grid, 
  Paper, 
  Tab, 
  Tabs, 
  styled 
} from "@mui/material";

const MainContentArea = styled(Paper)(({theme}) => ({
  ...theme.flexBox.justifyAlignCenter,
  height: '100%',
  width: '100%',
  flexWrap: 'wrap',
  backgroundColor: 'transparent'
}));

const CustomTabsComponent = styled(Tabs)(({theme}) => ({
  width: '100%',
  flex: '5',
  overflowX: 'scroll',
  '.MuiTabs-scrollButtons': {
    color: `${theme.palette.whites.main}`
  },
  '.MuiTabs-scrollButtons.Mui-disabled': {
    opacity: 0.3
  },
  '& .Mui-selected': {
    color: `${theme.palette.whites.main}!important`
  },
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.whites.main,
    height: 5,
  },
  color: `${theme.palette.secondary.md}!important`,
  display: 'flex',
  justifyContent: 'flex-start', // Centers the tabs
  '& .MuiTabs-flexContainer': {
    justifyContent: 'flex-start', // Centers the tabs within the container
  },
}));

const CustomTab = styled(Tab)(({ theme }) => ({
  color: `${theme.palette.whites.md}`
}));

const AvatarContainer = styled(Grid)(({theme}) => ({
  ...theme.flexBox.justifyStartAlignCenter,
  flex: '0.5',
  backgroundColor: `${theme.palette.primary.main}`,
  padding: '0!important',
  width: '100%',
}));

const TabsAndPanelsParentBox = styled(Box)(({theme}) => ({
  display: 'flex', 
  flexDirection: 'column', 
  width: '100%', 
  flex: '4', 
  height: '100dvh',
  backgroundColor: `transparent`
}));

const TabPanelChildrenContainer = styled(Container)(({theme}) => ({
  height: '100%',
  [theme.breakpoints.down('md')]: {
    padding: '0!important'
  }
}));

const MainContentAreaChildGrid = styled(Grid)(() => ({
  width: '100%'           , 
  height: '100%'          ,
  display: 'flex'         ,
  flexDirection: 'column' ,
  flexWrap: 'nowrap'      ,
}));

const TabsBox = styled(Box)(({ theme, isProfile }) => ({
  backgroundColor: `${theme.palette.primary.main}`,
  padding: '1rem',
  borderBottomLeftRadius: !isProfile && '2rem',  // Adjust size as needed
  borderBottomRightRadius: !isProfile && '2rem',
  border: `1px solid ${theme.palette.primary.main}`
}));

const EditProfilePaperContainer = styled(Paper)(({ theme }) => ({
  width: '100%', 
  margin: '1rem 5rem', 
  padding: '2rem',
  [theme.breakpoints.down('md')]: {
    margin: '1rem',
    padding: '1rem'
  }
}));

const UploadBox = styled(Paper)(({ theme, isDragActive }) => ({
  border: `2px dashed ${isDragActive ? theme.palette.primary.main : theme.palette.grey[300]}`,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(4),
  textAlign: 'center',
  backgroundColor: isDragActive ? theme.palette.grey[50] : 'transparent',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: theme.palette.grey[50],
    borderColor: theme.palette.primary.main,
  },
}));


export { 
  MainContentArea,
  MainContentAreaChildGrid,
  CustomTabsComponent,
  CustomTab,
  TabsAndPanelsParentBox,
  TabPanelChildrenContainer,
  AvatarContainer,
  TabsBox,
  EditProfilePaperContainer,
  UploadBox
};